import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    smsContactsList: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minHeight: '100%',
        alignItems: 'stretch',
        backgroundColor: theme.palette.background.paper,
    },
    smsContactsSearch: {
        padding: '12px 12px 10px',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        position: 'sticky',
        top: 0,
        borderStyle: 'hidden hidden solid hidden',
        borderWidth: 'thin',
        borderBottomColor: theme.palette.action.focus,
        backgroundColor: theme.palette.background.paper,
        zIndex: 1,
    },
    listHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: 4,
    },
    listTitle: {
        fontSize: 18,
        fontWeight: 500,
        lineHeight: 1.3,
        color: theme.palette.text.primary,
    },
    searchField: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '1px 6px 1px 10px',
        borderRadius: 8,
        backgroundColor: theme.palette.action.hover,
        color: theme.palette.text.secondary,
    },
    smsContactsSearchInput: {
        flex: 1,
        fontSize: 14,
        '& input': {
            padding: '6px 0px',
        },
        '& input::placeholder': {
            fontSize: 13,
        },
    },
    searchClear: {
        color: theme.palette.text.secondary,
    },
    emptyState: {
        padding: '32px 16px',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        fontSize: 14,
    },
    items: {
        flex: 1,
    },
    newSmsButton: {
        width: 32,
        height: 32,
        color: '#fff',
        background: theme.palette.primary.light,
        '&:hover': {
            background: theme.palette.primary.light,
            filter: 'brightness(0.93)',
        },
    },
}));

export { useStyles }
